import { KendraConst, SearchInterface } from "@amzn/ask-legal-domain";
import { Checkbox, ExpandableSection, SpaceBetween } from "@amzn/awsui-components-react";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";

export const FileTypeFilter = (props: {
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    disabled?: boolean;
}) => {
    const defaultTypeOptions = ["Page", "Document", "Link"];

    return (
        <ExpandableSection defaultExpanded={false} header="File type">
            <SpaceBetween direction="vertical" size="s">
                {defaultTypeOptions.map(t => (
                    <Checkbox
                        key={t}
                        checked={SearchInterface.SearchQueryInput.isFiltered(props.queryInputState.value, {
                            attribute: KendraConst.ContainerIngestionKendraAttributes.Custom.ContentType,
                            valueMap: {
                                value: t,
                                valueType: KendraConst.IndexAttributeType.STRING
                            }
                        })}
                        disabled={props.disabled}
                        onChange={e => {
                            if (e.detail.checked) {
                                props.queryInputState.setValue(
                                    SearchInterface.SearchQueryInput.applyFilter(props.queryInputState.value, {
                                        attribute: KendraConst.ContainerIngestionKendraAttributes.Custom.ContentType,
                                        operation: "EqualsTo",
                                        valueMap: {
                                            value: t,
                                            valueType: KendraConst.IndexAttributeType.STRING
                                        }
                                    })
                                );
                            } else {
                                props.queryInputState.setValue(
                                    SearchInterface.SearchQueryInput.removeFilter(props.queryInputState.value, {
                                        attribute: KendraConst.ContainerIngestionKendraAttributes.Custom.ContentType,
                                        operation: "EqualsTo",
                                        valueMap: {
                                            value: t,
                                            valueType: KendraConst.IndexAttributeType.STRING
                                        }
                                    })
                                );
                            }
                        }}>{t}
                    </Checkbox>
                ))}
            </SpaceBetween>
        </ExpandableSection>
    );
};
